import $ from 'jquery';
import isEmpty from 'lodash/isEmpty';
import ChartEvent from '../vcom/events/ChartEvent';
import ChartParameter from './const/ChartParameter';
import Base from '../vcom/Base';
import EventService from '../common/event/EventService';
import VcomProvider from '../VcomProvider';
import VcomSection from '../vcom/const/VcomSection';
import EventLoggingService from '../eventLogging/EventLoggingService';
import FrontendEvents from '../eventLogging/const/FrontendEvents';
import ContactService
  from '../administration/pages/contactList/contactManagement/service/ContactService';

export default function PeriodSelection() {
  let periodControl;
  let customRange = false;
  const chartsWithoutCustomRangeSection = [
    'B6T4V',
    '3D7PY',
    'Q6ZWP',
    'YWLNV',
    'C6DI3',
    'GBCPL',
    'BFDMT',
    'I5T4G',
    'DSLEN',
    'OGZ1P',
    'HMSII',
  ];

  function bindListeners(scope, options) {
    periodControl.on('change', 'button:not([disabled])', async (event) => {
      const updateFunc = options.updateFunc ?? null;
      const period = $(event.currentTarget).find('input').val();
      const isRangePickMode = options.pickerExtended.isRangePickMode();
      const isSingleDatePicker = options.pickerExtended.isSingleDatePicker();

      if (period !== 'custom') {
        if (isRangePickMode || !isSingleDatePicker) {
          options.pickerExtended.createDatepicker({
            rangePickMode: false,
            singleDatePicker: true,
          });
        }
      } else if (!isRangePickMode || isSingleDatePicker) {
        customRange = period;
        options.pickerExtended.createDatepicker({
          rangePickMode: true,
          singleDatePicker: false,
          linkedCalendars: false,
        });
      }
      options.pickerExtended.setRangePickMode(period === 'custom');
      options.pickerExtended.modifyStartAndEnd(period);

      if (options.minuteValuesToggle) {
        options.minuteValuesToggle.toggleDisabledState(period);
        options.minuteValuesToggle.toggleVisibilityPeriod(period);
      }

      if (VcomProvider.section === VcomSection.EVALUATION) {
        Base.setUrlQueryParameter(ChartParameter.PERIOD, period);
      }

      EventService.dispatch(ChartEvent.PERIOD_CHANGED);
      scope.chart('triggerChartUpdate', updateFunc, scope, { period });

      if (period === 'jahr' || period === 'custom') {
        const user = await ContactService.get(VcomProvider.userId);
        EventLoggingService.logFrontendEvent(
          FrontendEvents.PERIOD_CLICKED(period, user.userGroup),
        );
      }
    });
  }

  function getCurrentPeriod() {
    return periodControl.is('select')
      ? periodControl.val()
      : periodControl.find('input:checked')
        .val();
  }

  function removePeriodHighlighting() {
    periodControl
      .find('button.active')
      .removeClass('active');
  }

  function highlightPeriod(period) {
    if (periodControl.is('select')) {
      periodControl.val(period);
    } else {
      periodControl
        .find('input')
        .prop('checked', false)
        .filter(`[value='${period}']`)
        .prop('checked', true)
        .parent()
        .addClass('active');
    }
  }

  function togglePeriodsByAvailableChartPeriods(chartPeriods) {
    if (periodControl.is('select')) {
      periodControl.find(':option').each((index, element) => {
        $(element).prop('disabled', !chartPeriods.includes($(element).val()));
      });
    } else {
      periodControl.find('button').each((index, element) => {
        $(element).prop('disabled', !chartPeriods.includes($(element).find('input').val()));
      });
    }
  }

  function resetPeriods(chartPeriods, options) {
    removePeriodHighlighting();
    if (!isEmpty(chartPeriods)) {
      if (!chartsWithoutCustomRangeSection.includes(options.chart.key)) {
        chartPeriods = chartPeriods.concat('custom');
      }
      if (!chartPeriods.includes(options.period)) {
        [options.period] = chartPeriods;
      }
      togglePeriodsByAvailableChartPeriods(chartPeriods);
    }

    highlightPeriod(options.period);
  }

  function disableAllPeriods() {
    periodControl.find('button').each((index, element) => {
      $(element).prop('disabled', true);
    });
  }

  function isCustomRange() {
    return customRange;
  }

  function setCustomRange(value) {
    customRange = value;
  }

  return {
    init(periodControlElement, period) {
      periodControl = periodControlElement;
      if (period) {
        highlightPeriod(period);
      }
    },
    bindListeners,
    highlightPeriod,
    getCurrentPeriod,
    removePeriodHighlighting,
    resetPeriods,
    disableAllPeriods,
    isCustomRange,
    setCustomRange,
  };
}
